import React from 'react';
const Footer = () => {
    return (
        <div>
            <footer className="bg-[#0E223B] text-white font-semibold gap-2 py-8 text-center text-sm">
                <div className="max-w-7xl mx-auto px-4">
                    {/* Navigation Links */}
                    <div className="flex flex-wrap justify-center sm:text-xs md:text-base text-[11px] space-x-6 mb-4">
                        <a href="/contact" className="hover:text-gray-300">Contact</a>
                        <a href="/terms" className="hover:text-gray-300">Terms</a>
                        <a href="/privacy" className="hover:text-gray-300">Privacy</a>
                        <a href="/returns" className="hover:text-gray-300">Return Policy</a>
                        <a href="/disclaimer" className="hover:text-gray-300">Disclaimer</a>
                    </div>

                    {/* Disclaimers */}
                    <p className="text-gray-400 text-xs mb-4 font-normal">
                        Statements on this website have not been evaluated by the Food and Drug Administration. Products are not intended to diagnose, treat, cure, or prevent any disease.</p>
                    <p className="text-gray-400 text-xs mb-4 font-normal">
                        The website's content and the product for sale are based upon the author's opinion and are provided solely on an "AS IS" and "AS AVAILABLE" basis. You should do your own research and confirm the information with other sources when searching for information regarding health issues and always review the information carefully with your professional healthcare provider before using any protocols presented on this website and/or in the product sold here. Neither BuyGoods nor the author is engaged in rendering medical or similar professional services or advice via this website or in the product, and the information provided is not intended to replace medical advice offered by a physician or other licensed healthcare provider. You should not construe BuyGoods's sale of this product as an endorsement by BuyGoods of the views expressed herein or any warranty or guarantee of any strategy, recommendation, treatment, action, or application of advice made by the author of the product.
                    </p>
                    <p className="text-gray-400 text-xs mb-4 font-normal">
                        Some names and personal identifying information on this site have been changed to protect the privacy of individuals.
                    </p>
                    <div className='w-full pt-10 text-start text-xs text-gray-400 space-y-4'>
                        <p>
                            ClickBank is the retailer of this product. CLICKBANK® is a registered trademark of Click Sales, Inc., a Delaware corporation located at 1444 S. Entertainment Ave., Suite 410 Boise, ID 83709, USA and used by permission. ClickBank’s role as retailer does not constitute an endorsement, approval or review of this product or any claim, statement or opinion used in promotion of this product.
                        </p>
                        <p>
                            Statements on this website have not been evaluated by the Food and Drug Administration. Products are not intended to diagnose, treat, cure or prevent any disease. If you are pregnant, nursing, taking medication, or have a medical condition, consult your physician before using our products.
                        </p>
                        <p>
                            Testimonials, case studies, and examples found on this page are results that have been forwarded to us by users of "scalerespo" products and related products are not intended to represent or guarantee that anyone will achieve the same or similar results.
                        </p>
                        <p>
                            For Product Support, please contact the seller <a href='/contact' className='text-blue-600 hover:underline'>[HERE]</a>
                        </p>
                        <p>
                            For Order Support, please contact ClickBank{" "}
                            <a href='https://www.clkbank.com/' className='text-blue-600 hover:underline'>HERE*</a>
                        </p>
                    </div>

                    {/* Copyright */}
                    <p className="text-gray-400 text-xs font-normal mt-3">
                        &copy; {new Date().getFullYear()} Respoclear.net. All Rights Reserved.


                    </p>
                </div>
            </footer>
        </div>

    );
};

export default Footer;
